<template>
<section class="Public">
    <slot />
</section>
</template>

<script>

export default {
    name: "PublicLayout",
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layouts/central/PublicLayout.vue